import * as React from "react";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";

interface Props {
  visible: boolean;
}

const FuncComponent: React.FC<Props> = ({ visible }) => {
  return (
    <div>
      <Backdrop
        sx={{
          color: "#fff",
          zIndex: (theme) =>
            Math.max.apply(Math, Object.values(theme.zIndex)) + 1,
        }}
        open={visible}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </div>
  );
};
export default FuncComponent;
